<template>
<div>
  <md-dialog-alert
    v-if="isLoggedIn"
    :md-active.sync="show"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    :md-title="$t('message_payment_not_received_1')"
    :md-content="contentMessage"
    :md-confirm-text="$t('proceed')"
    @md-closed="onConfirm" />
  <md-dialog-alert
    v-if="isLoggedIn"
    :md-active.sync="modalConfirmShow"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    :md-title="$t('message_payment_not_confirm_1')"
    :md-content="$t('message_payment_not_confirm_2')"
    :md-confirm-text="$t('proceed')"
    @md-closed="onCheckConfirmPayment" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getLoggedUser, isTalentApp, getBillTalent, getBillColor, willPayColorAndTalent } from '../services/User.service'

export default {
  name: 'PaymentInfoModal',
  data() {
    return {
      userDetails: {
        paye: '',
        type_client: ''
      },
      show: false,
      modalConfirmShow: false,
      contentMessage: '',
      confirm: false,
      checkPaymentConfirm: false
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    ...mapActions(['setUserDetails']),
    onConfirm(){
      this.confirm = true
      if(this.confirm){
        this.$router.push({name:'Payment'});
      }
    },
    onCheckConfirmPayment(){
      this.checkPaymentConfirm = true
      if(this.checkPaymentConfirm){
        this.$router.push({name:'Questionnaire'});
      }
    },
    getUserData(){
      if(localStorage.getItem('userId')) {
        const userId=localStorage.getItem('userId');
        getLoggedUser(userId).then(response => {
          const userData = response.data.user_info
          let contentCodeTrans = isTalentApp() ? 'message_payment_not_received_2_talent' : 'message_payment_not_received_2'
          contentCodeTrans = willPayColorAndTalent(userData) ? 'message_payment_not_received_2_color_talent' : contentCodeTrans
          this.setUserDetails(userData);
          this.userDetails.paye = userData.paye
          this.contentMessage = this.$t(contentCodeTrans).replace("70", this.getTotalBill(userData))
          this.userDetails.type_client = userData.relation_groupe == null ? '' : userData.relation_groupe.type_client
          if(this.isWaitingPayment(userData) && userData.payment_confirm == false) {
            this.show = true;
            this.modalConfirmShow = false;
          } else if(this.isWaitingPayment(userData) && userData.payment_confirm == true) {
            this.show = false;
            this.modalConfirmShow = true;
          }
        }).catch(error => {
            console.log(error.response);
        })
      }
    },
    getTotalBill(userInfo){
      let totalAmount = 0;
      // je suis dans l'application talents
      if (isTalentApp()) {
        totalAmount = getBillTalent(userInfo)
        // je suis dans l'application couleurs
      } else {
        totalAmount = getBillColor(userInfo)
      }

      return totalAmount;
    },
    isWaitingPayment(userInfo){
      let ispaid = false

      // je suis dans l'application talents
      if (isTalentApp()) {
        ispaid = userInfo.talent_payement_date != null ? true : false
        // Dans le cas ou le questionnaire talent est gratuit
        if (parseInt(this.getTotalBill(userInfo))<= 0)
            ispaid = true
      // je suis dans l'application couleurs
      } else {
        ispaid = userInfo.paye != '' && userInfo.paye != null ? true : false
        // Dans le cas ou le questionnaire vente est gratuit
        if (parseInt(this.getTotalBill(userInfo))<= 0)
            ispaid = true
      }

      return !ispaid;
    }
  },
  mounted(){
    this.getUserData();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PaymentInfoModal.vue